import {Icon, IconProps} from '@chakra-ui/react';

export function CoinsIcon({active, ...props}: IconProps & {active?: boolean}) {
  return (
    <Icon width="17px" height="16px" viewBox="0 0 17 16" fill="none" {...props}>
      <path
        d="M11.5 2C9.72 2 8.164 2.942 7.278 4.349C6.725 4.132 6.13 4 5.5 4C2.743 4 0.5 6.243 0.5 9C0.5 11.757 2.743 14 5.5 14C7.277 14 8.821 13.056 9.705 11.653C10.264 11.869 10.866 12 11.5 12C14.257 12 16.5 9.757 16.5 7C16.5 4.243 14.257 2 11.5 2ZM5.5 12C3.846 12 2.5 10.654 2.5 9C2.5 7.346 3.846 6 5.5 6C5.882 6 6.245 6.075 6.58 6.208C6.538 6.469 6.5 6.728 6.5 7C6.5 8.409 7.091 9.679 8.033 10.589C7.502 11.434 6.569 12 5.5 12ZM11.5 10C9.846 10 8.5 8.654 8.5 7C8.5 5.346 9.846 4 11.5 4C13.154 4 14.5 5.346 14.5 7C14.5 8.654 13.154 10 11.5 10Z"
        fill={active ? '#EDB35C' : 'gray'}
      />
    </Icon>
  );
}
